import { createFileRoute } from "@tanstack/react-router";
import { PrivacySettings } from "../../../../features/settings/privacy/privacy-settings";

export const Route = createFileRoute("/w/$slug/settings/privacy")({ component: PrivacySettings });
